import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as birdChart } from './birdChart';
import { reducer as errorTable } from './errorTable';
import { reducer as dimensionTables } from './dimensionTables';
import { reducer as barChart } from './barChart';
import { reducer as sharing } from './sharing';
import { reducer as dashboard } from './dashboard';
import { reducer as tempDashboard } from './tempDashboard';

export default combineReducers({
  base,
  birdChart,
  errorTable,
  dimensionTables,
  barChart,
  sharing,
  dashboard,
  tempDashboard,
});
